import React from 'react'
import styled from 'styled-components'
import { Heading, Text } from '@swapxco/uikit'
import { Button } from 'components/Button'
import Page from 'components/Layout/Page'
import { useTranslation } from 'contexts/Localization'
import { Link } from 'react-router-dom'

const StyledNotFound = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 112px - 64px);
  justify-content: center;
  position: relative;
`

const LinkButton = styled(Button)`
  padding: 30px;
`

const NotFound = () => {
  const { t } = useTranslation()

  return (
    <Page>
      <StyledNotFound>
        {/* <img src="/images/404.svg" style={{ maxHeight: '40vh' }} alt="404" /> */}
        <video style={{
          height: '100vh',
          width: '100vw', position: "fixed",
          objectFit: "cover",
          objectPosition: "bottom 50%",
          top: 0,
          left: 0,
          zIndex: -1,
          filter: 'opacity(0.4) saturate(0.8)',
        }} autoPlay muted loop>
          <source src='/error_mascot.webm' />
        </video>
        {/* <LogoIcon width="64px" mb="8px" /> */}
        <Heading color="primary" scale="xxl">
          404
        </Heading>
        <Text color="contrast" m="16px">
          {t('Oops, page not found.')}
        </Text>
        <Link to="/">
          <LinkButton>{t('Back Home')}</LinkButton>
        </Link>
      </StyledNotFound>
    </Page>
  )
}

export default NotFound
